import styled, { css } from "styled-components";
import { theme } from "styles/mui-config";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import { Link } from "react-router-dom";
import Tab from "@mui/material/Tab";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";

const activeDrawerLink = ({ $isActive }) => {
  if ($isActive) {
    return css`
      color: ${theme.palette.primary.dark} !important;
    `;
  }
};

export const StyledListItemIcon = styled(ListItemIcon)`
  & svg {
    color: ${theme.palette.primary.main};
  }
`;

export const StyledLinkMobile = styled(Link)`
  color: #000000;
  display: flex;
  direction: rtl;
`;

export const StyledListItem = styled(ListItem)`
  // & a > div > svg {
  //   color: #009ac299 !important;
  // }
`;

export const StyledListItemText = styled(ListItemText)`
  & span {
    font-size: 15px;
    color: #222;
  }
`;

export const StyledAppBarDiv = styled.div`
  & > div {
    left: 0px;
  }
  @media (min-width: 1000px) {
    display: none !important;
  }
`;

export const StyledTabDiv = styled.div`
  padding-top: 10px;
`;

export const StyledBottomNavigationAction = styled(BottomNavigationAction)`
  ${activeDrawerLink},
  padding-top: 6px;
  & > span {
    font-size: 9px !important;
    opacity: 1;
  }
`;

export const StyledTab = styled(Tab)`
  width: 50% !important;
`;

export const StyledLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
  background-color: transparent;
  outline: 0;
  border: 0;
  margin: 0;
  border-radius: 0;
  padding: 0;
  cursor: pointer;
  user-select: none;
  vertical-align: middle;
  -moz-appearance: none;
  -webkit-appearance: none;
  text-decoration: none;
  color: inherit;
  transition: color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    padding-top 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  padding: 0px;
  min-width: 80px;
  max-width: 168px;
  color: rgba(0, 0, 0, 0.6);
  flex-direction: column;
  flex: 1;
  & > button {
    width: 100%;
    height: 100%;
    padding: 6px 12px 8px;
  }
`;
